<template>
    <main-content with_go_back_bar>
        <div v-if="status == 'success'">
            <kt-panel v-if="!activeGateways().has_gateway">
                <kt-panel-body>
                    <p class="font-weight-bolder text-center" :style="{fontSize: '15px'}">
                        {{ $t('message.no_gateway') }}
                        <router-link
                                class="btn btn-brand d-block w-25 text-center align-content-center mx-auto mt-3"
                                to="/gateways"> {{ $t('btn.create_gateway') }}
                        </router-link>
                    </p>
                </kt-panel-body>
            </kt-panel>
            <kt-panel v-else-if="!activeGateways().has_active_gateway">
                <kt-panel-body>
                    <p class="font-weight-bolder text-center" :style="{fontSize: '15px'}">
                        {{ $t('message.no_active_gateway') }}
                    </p>
                </kt-panel-body>
            </kt-panel>
            <kt-panel v-else-if="gateway_didnt_set_in_pardakht_shakhsi">
                <kt-panel-body>
                    <p class="font-weight-bolder text-center" :style="{fontSize: '15px'}">
                        {{ $t('message.gateway_didnt_set_in_pardakht_shakhsi') }}
                    </p>
                </kt-panel-body>
            </kt-panel>
            <kt-panel v-else-if="gateway_which_set_in_pardakht_shakhsi_is_not_active">
                <kt-panel-body>
                    <p class="font-weight-bolder text-center" :style="{fontSize: '15px'}">
                        {{ $t('message.gateway_which_set_in_pardakht_shakhsi_is_not_active') }}
                    </p>
                </kt-panel-body>
            </kt-panel>
            <money-request-form v-else
                                :submitSingleRequest="submitSingleRequest"
                                :submitGroupRequest="submitGroupRequest"
            >
            </money-request-form>
        </div>
    </main-content>
</template>

<script>
    import mainContent from '@/components/main-content'
    import {gatewayTypes} from "@/constants/gatewayTypes";
    import Form from './components/form'
    import $ from "jquery";
    import {i18n} from "@/plugins/i18n";
    import {mapGetters} from "vuex";
    import {KTApp} from "@/plugins/core/app";
    import {moneyRequestService} from "@/common/api.service";
    import {gatewayStatus} from '@/constants/gatewayStatus';

    export default {
        components: {
            'main-content': mainContent,
            'money-request-form': Form
        },
        computed: {
            ...mapGetters('gateway', [
                'gateways', 'status'
            ]),
            ...mapGetters('pardakhtShakhsi', [
                'form_data',
            ]),
            gateway_didnt_set_in_pardakht_shakhsi() {
                return (this.form_data.shop_id == null);
            },
            gateway_which_set_in_pardakht_shakhsi_is_not_active() {
                return (this.form_data.shop_status != this.gatewayStatus.ACTIVE);
            },
        },
        data() {
            return {
                gatewayStatus: gatewayStatus,
            };
        },
        methods: {
            submitSingleRequest(e, query) {
                let form = $('#single-request-form')
                let btn = $('#form-btn')

                form.validate({
                    rules: {
                        full_name: {
                            required: true
                        },
                        amount: {
                            required: true,
                        },
                        phone: {
                            required: true,
                            minlength: 11,
                            digits: true
                        },
                        description: {
                            maxlength: 200,
                        },
                        payment_method : {
                            required : true
                        }
                    }
                })

                if (!form.valid())
                    return;

                KTApp.progress(btn)

                let descrition = query.description;
                if (descrition == undefined || descrition == 'undefined') {
                    descrition = '';
                }


                let params = {
                    full_name: query.full_name,
                    phone: query.phone,
                    amount: query.amount,
                    description: descrition,
                    payment_method: query.payment_method,
                    // payment_method : 1,
                }

                moneyRequestService.create(params).then(response => {
                    this.showMsg(form, 'success', response.data.message)
                }).catch(({response}) => {
                    if(response.data) {
                        if (response.data.data.fail_reason == "not_enough_charge") {
                            let message = String(response.data.message) + i18n.t('money_request.goto_sms_notification_settings_for_recharge') + '<a class="btn mx-2 p-1" href="/notification-sms" style="background: #dedede; color: #000" target="_blank">' + i18n.t('notification.label.recharge') + '</a>';
                            this.showMsg(form, 'danger', message);
                        } else {
                            form.validate().showErrors(response.data.data);
                        }
                    }
                }).finally(() => {
                    KTApp.unprogress(btn)
                })
            },
            submitGroupRequest(e, query) {
                let form = $('#gregarious-request-form')
                let btn = $('#excel-form-btn')

                form.validate({
                    rules: {
                        file: {
                            required: true
                        },
                        payment_method :{
                            required : true
                        }
                    }
                })

                if (!form.valid())
                    return;

                KTApp.progress(btn)

                let params = {
                    file: query.file,
                    payment_method: query.payment_method
                    // payment_method: 1
                }

                moneyRequestService.create(params).then(response => {
                    this.showMsg(form, 'success', response.data.message)
                }).catch(({response}) => {
                    if(response.data) {
                        form.validate().showErrors(response.data.data)
                    }
                    this.showMsg(form, 'danger', response.data.message)
                }).finally(() => {
                    KTApp.unprogress(btn)
                })
            },
            backToMoneyRequestsList() {
                this.$router.push('/money-request')
            },

            activeGateways() {
                if (this.gateways.current_page)
                    return this.activeGatewaysWithManageAccess()

                var active_gateways = []

                if (!this.gateways || this.gateways.length < 1) {
                    active_gateways.has_gateway = false
                    return active_gateways
                }

                active_gateways.has_gateway = true

                active_gateways.gates = []
                active_gateways.has_active_gateway = false
                var gateway
                for (gateway of this.gateways) {
                    if ((gateway.status === 1 || gateway.status === '1') && gateway.gateway_type == gatewayTypes.PARDAKHTYARI) {
                        active_gateways.gates.push(gateway)
                        active_gateways.has_active_gateway = true
                    }

                }
                return active_gateways
            },
            activeGatewaysWithManageAccess() {
                var gateways
                gateways = this.gateways.data

                var active_gateways = []

                if (!gateways || gateways.length < 1) {
                    active_gateways.has_gateway = false
                    return active_gateways
                }

                active_gateways.has_gateway = true

                active_gateways.gates = []
                active_gateways.has_active_gateway = false
                var gateway

                for (gateway of gateways) {
                    if ((gateway.status === 1 || gateway.status === '1')) {
                        active_gateways.gates.push(gateway)
                        active_gateways.has_active_gateway = true
                    }

                }
                return active_gateways
            }
        },
        mounted() {
            this.$store.dispatch('gateway/fetch');
            this.$store.dispatch('pardakhtShakhsi/fetch');
        }
    }
</script>
